<template>
  <div class="default-title">
     <el-form label-width="120px" ref="form" :model="form" class="list-top-margin" :size="buttonSize" :rules="rules">
        <el-row>
          <el-col :span="24">
            <el-form-item label="不良品项编号" prop="nongoodCode">
              <el-input size="small" v-model="form.nongoodCode" placeholder="请输入，忽略将自动生成" :disabled="disableCode" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="不良品项名称" prop="nongoodName">
              <el-input size="small" v-model="form.nongoodName" placeholder="请输入" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="text-align-center" style="position: relative;">
        <el-button size="small" @click="cancel">取 消</el-button>
        <el-button size="small" type="primary" class="title" @click="save">确 定</el-button>
      </div>
  </div>
</template>
<script>
import { nongoodSave } from '@/api/basicData'
import Pagination from '@/components/Pagination'
export default {
  components: {
    Pagination,
  },
  props:['editRow','userData','modelStatus'],
  data() {
    return {
      buttonSize:'small',
      form:{
        nongoodCode:'',
        nongoodName:'',
        _id:'',
      },
      rules:{
        nongoodName: [{
            required: true,
            message: "请输入名称",
            trigger: "blur",
        },] ,
      },
      disableCode:false
    }
  },
  created() {
    if(this.modelStatus == 'edit'){
      this.disableCode = true
      this.form.nongoodCode = this.editRow.nongoodCode
      this.form.nongoodName = this.editRow.nongoodName
      this.form._id = this.editRow._id
    }
  },
  methods:{
    cancel(){
      this.$emit('done',{type:'cancel'})
    },
    save(){
      this.$refs.form.validate((valid) => {
          if (valid) {
            var data = {
              factoryId: this.userData.factoryId,
              nongoodCode: this.form.nongoodCode,
              nongoodName: this.form.nongoodName,
              _id:this.form._id
            }
            nongoodSave(data).then(res => {
              if(res.code == 200){
                this.$message.success('保存成功')
              }else{
                this.$message.error(res.msg)
              }
              this.$emit('done',{type:'save'})
            }).catch(err => {
              this.$message.error(err)
            })
          }
      })

    },
  }
}
</script>
<style>
.list-top-margin .el-input-group__append, .el-input-group__prepend{
  color: #fff;
  background-color: #409EFF;
  border-radius: 0 4px 4px 0;
}
.select-count-content{
  position: absolute;
  left: 0;
  top: -45px;
  font-size: 12px;
}
</style>




// WEBPACK FOOTER //
// src/views/basicData/defectiveProduct/create-dialog.vue